import { publisherFontAwesomeIconsEnum } from 'common/constants/fontAwesomeConst'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'
import {
  PriceElementPeriodInterface,
  PriceElementSliderInterface,
} from '../price-element-interface'
import { CommonPriceElementUnknownUi } from '../ui'
import {
  PriceElementPlanButtonUi,
  PriceElementPlanPriceUi,
  PriceElementPlanPriceWrapperUi,
  PriceElementPlansContainerUi,
  PriceElementPlansPaginationButtonUi,
  PriceElementPlansPaginationUi,
  PriceElementPlansUi,
  PriceElementPlansWrapperUi,
  PriceElementPlanTitleUi,
  PriceElementPlanUi,
} from './ui'

interface CommonPriceElementPlansProps extends PriceElementSliderInterface {
  plans: PriceElementPeriodInterface[]
  locale: PageLocaleEnum
  t: TFunction
  isLoading: boolean
  onClick: (id: number) => void
  goToNext: () => void
  goToPrev: () => void
}

export const CommonPriceElementPlans = ({
  plans,
  onClick,
  locale,
  t,
  isLoading,
  sliderRef,
  currentIndex,
  goToPrev,
  goToNext,
  handleTouchStart,
  handleTouchMove,
  handleEnd,
  handleMouseDown,
  handleMouseMove,
  sliderStyles,
}: CommonPriceElementPlansProps) => {
  const handlePopupBtn = (idx: number) => {
    if (isLoading) {
      return false
    }
    onClick(idx)
  }

  return (
    <PriceElementPlansWrapperUi>
      <PriceElementPlansPaginationUi>
        <PriceElementPlansPaginationButtonUi
          type="button"
          onClick={goToPrev}
          disabled={isLoading || currentIndex === 0}
        >
          <i
            className={publisherFontAwesomeIconsEnum.ChevronCircleLeftLight}
            id="left-arrow"
          />
        </PriceElementPlansPaginationButtonUi>
        <PriceElementPlansPaginationButtonUi
          type="button"
          onClick={goToNext}
          disabled={isLoading || currentIndex === 3}
        >
          <i
            className={publisherFontAwesomeIconsEnum.ChevronCircleRightLight}
            id="right-arrow"
          />
        </PriceElementPlansPaginationButtonUi>
      </PriceElementPlansPaginationUi>
      <PriceElementPlansContainerUi
        ref={sliderRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleEnd}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
      >
        <PriceElementPlansUi
          isDisabled={isLoading}
          locale={locale}
          style={sliderStyles}
        >
          {plans.map((plan, idx) => (
            <PriceElementPlanUi key={plan.title ?? `${idx}`}>
              <PriceElementPlanTitleUi locale={locale}>
                {plan.title ?? <CommonPriceElementUnknownUi />}
              </PriceElementPlanTitleUi>
              <PriceElementPlanPriceWrapperUi>
                <PriceElementPlanPriceUi locale={locale}>
                  {plan.cost ?? <CommonPriceElementUnknownUi width="30px" />}
                </PriceElementPlanPriceUi>
                /
                {plan.period ? t(plan.period) : <CommonPriceElementUnknownUi />}
              </PriceElementPlanPriceWrapperUi>
              <PriceElementPlanButtonUi
                type="button"
                locale={locale}
                onClick={() => handlePopupBtn(idx)}
                isDisabled={isLoading}
              >
                {t('components.price_element.popup_button')}
              </PriceElementPlanButtonUi>
            </PriceElementPlanUi>
          ))}
        </PriceElementPlansUi>
      </PriceElementPlansContainerUi>
    </PriceElementPlansWrapperUi>
  )
}
